// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Jm7ko","icon":"Card_icon__84-SV","label":"Card_label__+rI9x","radioContainer":"Card_radioContainer__zg4JK"};